import React, {useState,Fragment, useEffect} from "react";

import "./Footer.css";
import Category from "./Category";
import ModalContactUs from "../ModalContactUs/ModalContactUs";
// import {Button} from 'primereact/button';

const Footer = function (props) {
    const [showModal, setShowModal] = useState(false);
    const [categoriesLinks,setCategoriesLinks] = useState([]);
    const [sharesLinks,setSharesLinks] = useState([]);
    const [newsletterLink,setNewsletterLink] = useState('');


    useEffect(()=>{
            const obj = props.items.filter(x=> {return x['mashanFooterLinkGroup'].indexOf("ShareLinks")===-1 && x['mashanFooterLinkGroup'].indexOf("Buttons")===-1})
                                   .reduce(function (temp, item) {
                if (!temp[item.mashanFooterLinkGroup] ){
                        temp[item.mashanFooterLinkGroup] = [];
                    }
                    temp[item.mashanFooterLinkGroup].push(item.MashanLinkBtn);
                return temp;
            }, Object.create(null));
            let cat = Object.keys(obj).sort().map((key,index) => {
                let tempWide=3;
                if(index ===0){
                    tempWide=2;
                }
                else if(index ===1){
                    tempWide=6;
                }
                return <Category title={key.split(":")[1]} items={obj[key]}  key={"Footer_"+index} wide={tempWide}/>;
            });
            const sharesTemp = props.items.filter(x=> x['mashanFooterLinkGroup'].indexOf("ShareLinks")===0).map((tempItem,idx)=>{
                                                if(!!tempItem.MashanLinkBtn && !!tempItem.MashanLinkBtn.NavigateUrl){
                                                    let isMail = false; 
                                                    if(tempItem.MashanLinkBtn.NavigateUrl.indexOf('@')>-1){
                                                        isMail = true;
                                                    }
                                                        return <a key={idx} target='_blank' id={isMail?  "footer-mail-id":"footer-linkedin-id"} className={isMail?  'share-mail':'share-linkedin'}
                                                        href={tempItem.MashanLinkBtn.NavigateUrl}></a>;
                                                }
            });
            props.items.filter(x=> x['mashanFooterLinkGroup'].indexOf("Buttons")===0).map((tempItem,idx)=>{
                if(!!tempItem.mashanFooterLink || !!tempItem.MashanLinkBtn.NavigateUrl){
                    
                    setNewsletterLink(tempItem.mashanFooterLink);
                }
            });
            setSharesLinks(sharesTemp);
            setCategoriesLinks(cat);
            // let accessabilityMenuMobileArr = document.getElementsByClassName('bottomMobileMenuAccessibility');
            // if(accessabilityMenuMobileArr.length>0){
            //     accessabilityMenuMobileArr[0].style.width = window.screen.width;
            // }
        },[]);
        useEffect(()=>{
            if(sharesLinks.length>0){
                AddHrefAttributeForSocialLinks();
            }
        },[sharesLinks]);

        // copy link to share links on the master page
        const AddHrefAttributeForSocialLinks=()=> {
          
            let linkedinLink = document.getElementById('footer-linkedin-id');
            let mailLink = document.getElementById('footer-mail-id');
            if (!!linkedinLink && !!linkedinLink.getAttribute("href") && !!document.getElementById('master-share-linkedin-id') > 0){
                    let masterShareLink = document.getElementById('master-share-linkedin-id');
                    masterShareLink.href = linkedinLink.href;
            }
            
            if (!!mailLink && !!mailLink.getAttribute("href") && !!document.getElementById('master-share-mail-id') > 0){
                    let mailMasterShareLink = document.getElementById('master-share-mail-id');
                    mailMasterShareLink.href = mailLink.href;
            }
            let accessWheelChair = document.getElementsByClassName('access-module accessBtn');
            if(accessWheelChair.length > 0){
                var customIcon = document.createElement("i");
                
                customIcon.classList.add("fa");
                customIcon.classList.add("fa-wheelchair");
                accessWheelChair[0].appendChild(customIcon);
                accessWheelChair[0].classList.add("moving-wheelchair");
                let topPx=accessWheelChair[0].offsetTop-20;
             
                let accessabilityMenuId = document.getElementById("collapseAcces");
                accessabilityMenuId.style.right = '20px';
             
                accessabilityMenuId.style.top = accessWheelChair[0].offsetTop-50+'px';
            }

        };

    const ContactMeModal=()=>{
        window.scrollTo(0,200);
        setShowModal(true);
    };
    const CloseModal=()=>{
        setShowModal(false);
    };
    const SubscribeNewsLetter=()=>{
            window.location.href = newsletterLink;
    };  
    return (
        <React.Fragment>
      {showModal && <ModalContactUs  showModal={showModal} CloseModal={CloseModal} mainURL={props.mainURL}/>}
            <div className=" col-12  col-md-4 footer-btn-warpper">
            <div className="logo-icons col-12  col-md-12 ">
                <a className={'state-logo'} title='MOD Home' href="https://mod.gov.il"></a>
                <a className={'dept-logo'} title='Mashan Home' href="https://mission-ny.mod.gov.il"></a>
                </div>
                <div className="footer-text col-12 col-md-12  btn-footer-newsletter"> 
                {!!newsletterLink && <>
                    <div>Subscribe to RFIs and Conventions Newsletter</div>
                    <button type='button' className='btn btn-outline-primary col-12  col-md-5' 
                                onClick={SubscribeNewsLetter}
                                >SUBSCRIBE</button>
                </>}
                </div>
                </div>   
                 <ul className="row footerCont no-gutters col-md-10">
                     {categoriesLinks}
                     <div>
                        <div className="footer-buttom-area  col-12  col-md-11">
                            <button type='button' className='btn btn-primary '
                            //col-12 col-md-3
                            onClick={ContactMeModal}>PLEASE CONTACT ME</button>
                                <div className="footer-share-links col-12 col-md-3">                            
                                            {sharesLinks}
                                </div>
                            </div>
                       
                        </div>
                  </ul>
       </React.Fragment>
    );

}
export default Footer;
